<div class="modal-box add-order-modal" cdkDrag>
    <form class="add-order-modal__form modal-form" [formGroup]="addForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-order-modal__header" cdkDragHandle>
            <div class="add-order-modal__headline modal-headline">
                <span class="add-order-modal__eyebrow modal-eyebrow">{{ 'ORDER' | translate }}</span>
                <h4 class="modal-title add-order-modal__title modal-heading">{{ 'ADD_ORDER_TO_SUBSCRIPTION' | translate }}</h4>
            </div>
            <button type="button" class="add-order-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-order-modal__body">
            <div class="add-order-modal__sections modal-sections">
                <section class="add-order-modal__panel add-order-modal__panel--wide modal-panel">
                    <div class="add-order-modal__panel-header modal-panel-header">
                        <span class="add-order-modal__panel-eyebrow modal-panel-eyebrow">{{ 'ORDER' | translate }}</span>
                        <h5 class="add-order-modal__panel-title modal-panel-title">{{ 'SUBSCRIPTION_AND_BILLING_PERIOD' | translate }}</h5>
                    </div>

                    <div class="add-order-modal__grid modal-grid">
                        <div class="add-order-modal__field add-order-modal__field--span-2">
                            <label class="add-order-modal__label" for="subscriptionId">{{ 'SUBSCRIPTION' | translate }}</label>
                            <ng-select id="subscriptionId"
                                class="add-order-modal__select"
                                formControlName="subscriptionId"
                                [ngClass]="{ 'is-invalid': submitted && f.subscriptionId.errors }"
                                bindLabel="value"
                                bindValue="id"
                                [items]="allSubscriptions">
                            </ng-select>
                            <div *ngIf="submitted && f.subscriptionId.errors" class="add-order-modal__feedback">
                                <div *ngIf="f.subscriptionId.errors.required">{{ 'SUBSCRIPTION_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-order-modal__field add-order-modal__field--span-2">
                            <label class="add-order-modal__label" for="period">{{ 'PERIOD' | translate }}</label>
                            <input id="period" mwlFlatpickr [altInputClass]="'datetime add-order-modal__alt-input'" mode="range" [altInput]="true"
                                [convertModelValue]="false" formControlName="period" class="form-control add-order-modal__control"
                                [ngClass]="{ 'is-invalid': submitted && f.period.errors }" [placeholder]="'SELECT_PERIOD' | translate">
                            <div *ngIf="submitted && f.period.errors" class="add-order-modal__feedback">
                                <div *ngIf="f.period.errors.required">{{ 'PERIOD_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-order-modal__panel modal-panel">
                    <div class="add-order-modal__panel-header modal-panel-header">
                        <span class="add-order-modal__panel-eyebrow modal-panel-eyebrow">{{ 'PAYMENT' | translate }}</span>
                        <h5 class="add-order-modal__panel-title modal-panel-title">{{ 'AMOUNT_AND_STATUS' | translate }}</h5>
                    </div>

                    <div class="add-order-modal__grid add-order-modal__grid--single modal-grid">
                        <div class="add-order-modal__field">
                            <label class="add-order-modal__label" for="amount">{{ 'AMOUNT' | translate }}</label>
                            <div class="add-order-modal__currency-shell" [ngClass]="{ 'is-invalid': submitted && f.amount.errors }">
                                <span class="add-order-modal__currency-prefix">$</span>
                                <input id="amount" type="text" class="form-control add-order-modal__control add-order-modal__control--currency" (blur)="transformAmount()"
                                    formControlName="amount" [ngClass]="{ 'is-invalid': submitted && f.amount.errors }"
                                    [placeholder]="'ENTER_AMOUNT' | translate">
                            </div>
                            <div *ngIf="submitted && f.amount.errors" class="add-order-modal__feedback">
                                <div *ngIf="f.amount.errors.required">{{ 'AMOUNT_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-order-modal__field">
                            <label class="add-order-modal__label" for="paid">{{ 'PAID' | translate }}</label>
                            <div class="add-order-modal__toggle-shell">
                                <input tabindex="-1" class="form-check-input" type="checkbox" formControlName="isPaid" id="paid">
                                <label class="add-order-modal__toggle-label" for="paid">{{ 'MARK_AS_PAID' | translate }}</label>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer add-order-modal__footer" cdkDragHandle>
            <div class="add-order-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-order-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="submit" class="blue-button add-order-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
